import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignSingleCriteria",
  components: {
    InlinePrompt
  },
  props: {
    exitCriteria: {
      type: Boolean,
      default: false
    },
    automation: {
      type: Object,
      required: true
    },
    trigger: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState("DripCampaignStore", ["triggerMapper"])), {}, {
    triggerSelected() {
      return this.trigger.type;
    },
    triggersDropdownText() {
      return this.triggerSelected ? this.triggerMapper[this.trigger.type].name : this.$t("automations.selectTrigger");
    },
    triggersDropdownStyle() {
      return this.triggerSelected ? this.triggerMapper[this.trigger.type].style : "";
    },
    args() {
      return this.triggerSelected ? this.triggerMapper[this.trigger.type].arguments : [];
    },
    triggersToUse() {
      const triggerTypesToIgnoreIfExitCriteria = ["client-profile-created"];
      if (this.exitCriteria) {
        var _context;
        return _filterInstanceProperty(_context = this.automation.triggers).call(_context, t => !_includesInstanceProperty(triggerTypesToIgnoreIfExitCriteria).call(triggerTypesToIgnoreIfExitCriteria, t.key));
      } else {
        return this.automation.triggers;
      }
    }
  }),
  methods: {
    argumentDropdownText(argument) {
      if (this.trigger.metadata[argument.id]) {
        var _this$argumentObj;
        return ((_this$argumentObj = this.argumentObj(argument)) == null ? void 0 : _this$argumentObj.name) || argument.placeholder;
      } else {
        return argument.placeholder;
      }
    },
    argumentObj(argument) {
      var _context2;
      const argObj = _findInstanceProperty(_context2 = _valuesInstanceProperty(argument)).call(_context2, val => val.value === this.trigger.metadata[argument.id].toString());
      if (!argObj) {
        this.handleEmitArgument(argument.id, undefined);
      }
      return argObj;
    },
    argumentError(argument) {
      return !this.trigger.metadata[argument.id];
    },
    argumentValues(argument) {
      var _this$trigger$metadat;
      if (argument.id === "status" && (_this$trigger$metadat = this.trigger.metadata) != null && _this$trigger$metadat.board) {
        var _context3;
        return _filterInstanceProperty(_context3 = _valuesInstanceProperty(argument)).call(_context3, value => value.boardId.toString() === this.trigger.metadata.board.toString());
      }
      return _valuesInstanceProperty(argument);
    },
    handleTriggerClick(trigger) {
      const data = {
        type: trigger.key,
        metadata: {}
      };
      this.$emit("trigger-change", data);
    },
    handleArgumentClick(value, argument) {
      this.handleEmitArgument(argument.id, value.value.toString());
    },
    handleEmitArgument(argumentId, value) {
      var _this$trigger$metadat2;
      const data = {
        [argumentId]: value
      };
      if (argumentId === "board" && (_this$trigger$metadat2 = this.trigger.metadata) != null && _this$trigger$metadat2.status) {
        data.status = "";
      }
      this.$emit("argument-change", data);
    },
    handleDelete() {
      this.$emit("criteria-delete");
    }
  }
});